import styled from 'styled-components';
import { Button } from 'antd';
import colors from 'theme/colors';

export const AddContractTermBtn = styled(Button)`
  background-color: rgba(24, 144, 255, 0.07);
  color: ${colors.primary};
  border-color: ${colors.primary};
  margin-bottom: 1.25rem;

  &:hover {
    filter: brightness(1);
  }
`;
